import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HeatIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";

export const AdjustableLoadElectricHeatPumpForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } = useFormModel<
        ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_HEAT_PUMP
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Wärmeanlage
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            z. B. Speicherheizung, Wärmepumpe etc.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sofern bereits heute eine Wärmepumpe an der Bauadresse existiert, ist diese hier zu erfassen.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Hinweis: Angaben zur neuen Wärmepumpe machen Sie bitte auf der nächsten Seite.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricHeatPump.value.installed}
                        {...getFieldProps("adjustableLoadElectricHeatPump.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.adjustableLoadElectricHeatPump.value.installed = checked;
                                values.adjustableLoadElectricHeatPump.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricHeatPump.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.adjustableLoadElectricHeatPump.value.demand.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricHeatPump.value.demand.unit}
                            value={values.adjustableLoadElectricHeatPump.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.adjustableLoadElectricHeatPump.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricHeatPump.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
